<div class="wrapper"
     [ngClass]="{ 'horizontal-wrapper': direction === 'horizontal', 'vertical-wrapper': direction === 'vertical' }">
    <button type="button"
            [class.ripple]="!min || value > min"
            (click)="dec()"
            [disabled]="value <= min">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M19 13H5v-2h14v2z"/><path d="M0 0h24v24H0z" fill="none"/>
        </svg>
    </button>

    <div>{{ value }}</div>

    <button type="button"
            [class.ripple]="!max || value < max"
            (click)="inc()"
            [disabled]="value >= max">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/><path d="M0 0h24v24H0z" fill="none"/>
        </svg>
    </button>
</div>
